import React, { useState, useRef, useEffect } from "react";
import { useHistory } from "react-router-dom";
import ReactPlayer from "react-player/lazy";
import screenfull from "screenfull";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import { screeningsData } from "../../utils/screenings";
import PlayerControls from "../../components/player/PlayerControls";
import store from '../../services/store';
import Modal from "@material-ui/core/Modal";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";

const useStyles = makeStyles((theme) => ({
  main: {
    height: "100vh",
    paddingTop: 100,
    backgroundColor: "#fff",
    [theme.breakpoints.down("md")]: {
      backgroundColor: "#f5faff",
      paddingLeft: 20,
      paddingRight: 20,
      paddingTop: 40,
    },
  },
  leftRoot: {
    width: 170,
    marginRight: 20,
    marginTop: 76,
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  leftRootMd: {
    display: "none",
    [theme.breakpoints.down("md")]: {
      display: "flex",
    },
  },
  rightRoot: {
    width: 860,
    [theme.breakpoints.down("lg")]: {
      width: 800,
    },
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
  root: {
    position: "relative",
    width: "100%",
    minWidth: 860,
    minHeight: 489,
    [theme.breakpoints.down("lg")]: {
      minWidth: 700,
    },
    [theme.breakpoints.down("md")]: {
      width: "100%",
      minWidth: "auto",
      minHeight: "auto",
      height: "auto",
    },

    // marginTop: 80,
  },
  contents: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    width: "100%",
    marginTop: 100,
  },
  playerWrapper: {
    width: "100%",
    minHeight: "483px",
    position: "relative",
    border: "1px solid #c6c6c6",
    [theme.breakpoints.down("md")]: {
      minHeight: "auto",
    },
  },
  titleMain: {
    zIndex: 10,
    width: "400px",
    top: 0,
    left: 0,
    right: 0,
    "&> div": {
      marginLeft: 16,
      marginTop: 16,
      color: "#fff",
      padding: 12,
      borderRadius: 4,
      background: "#333333",
      width: 300,
      textAlign: "center",
    },
  },
  titleText: {
    fontSize: 32,
    [theme.breakpoints.down("sm")]: {
      fontSize: 20
    },
  },
  next: {
    zIndex: 10,
    width: "100%",
    height: "100%",
    padding: 16,
    "& > div": {
      width: 150,
      height: 45,
      backgroundColor: "rgb(47 55 61 / 95%)",
      borderRadius: 5,
      color: "rgb(240 240 240)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      lineHeight: 1.5,
      cursor: "pointer",
      "&:hover": {
        backgroundColor: "rgb(47 55 61 / 100%)",
        color: "#fff",
      },
    },
  },
  playerMain: {
    position: "absolute",
    width: "100%",
    height: "100%",
    background: "#333",
    zIndex: 12,
    border: "1px solid #333333",
    backgroundImage:
      "linear-gradient(rgb(51 51 51 / 55%), rgb(0 0 0 / 87%)),url(/images/breast/breast_0.png)",
    backgroundSize: "962px 540px",
  },
  leftButton: {
    width: 170,
    height: 116,
    border: "1px solid #e3e3e3",
    marginBottom: 14,
    background: "#dee8f4",
    cursor: "pointer",
    textAlign: "center",
    [theme.breakpoints.down("md")]: {
      marginTop: 40,
      width: '32%',
      height: 90,
      background: "#f5faff",
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: 10,
      width: '32%',
      height: 60,
      background: "#f5faff",
    },
  },
  topButton: {
    width: 110,
    height: 56,
    border: "1px solid #e3e3e3",
    marginBottom: 14,
    background: "#dee8f4",
    cursor: "pointer",
    textAlign: "center",
  },
  titleLine: {
    marginBottom: 32,
    [theme.breakpoints.down("md")]: {
      justifyContent: "center",
    },
  },
  footer: {
    marginTop: 24,
    [theme.breakpoints.down("md")]: {
      justify: "flex-end",
      alignItems: "center"
    },
  },
  nextButton: {
    width: 194,
    height: 70,
    background: "#10459a",
    borderRadius: 9,
    color: "white",
    marginRight: 20,
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
    },
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  nextButtonSmall: {
    display: "none",
    [theme.breakpoints.down("md")]: {
      width: "260px",
      display: "flex",
      // width: 194,
      marginRight: 10,
      height: 70,
      background: "#10459a",
      borderRadius: 9,
      color: "white",
      cursor: "pointer",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100px",
      display: "flex",
      // width: 194,
      height: 50,
      marginRight: 10,
      background: "#10459a",
      borderRadius: 9,
      color: "white",
      cursor: "pointer",
    },

    // "&:hover": {
    //   backgroundColor: theme.palette.primary.main,
    // },
  },
  prevButton: {
    width: 194,
    height: 70,
    background: "#f5faff",
    borderRadius: 9,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: "#10459a",
    color: "#10459a",
    marginRight: 20,
    cursor: "pointer",
    "&:hover": {
      backgroundColor: '#c5cacf',
    },
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  prevButtonSmall: {
    display: "none",
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: "#10459a",
    [theme.breakpoints.down("md")]: {
      width: "260px",
      display: "flex",
      // width: 194,
      height: 70,
      marginRight: 10,
      background: "#f5faff",
      borderRadius: 9,
      color: "#10459a",
      cursor: "pointer",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100px",
      display: "flex",
      // width: 194,
      height: 50,
      marginRight: 10,
      background: "#f5faff",
      borderRadius: 9,
      color: "#10459a",
      cursor: "pointer",
    },

    // "&:hover": {
    //   backgroundColor: theme.palette.primary.main,
    // },
  },
  logo: {
    backgroundImage: "url(/images/logo-korean.jpg)",
    backgroundRepeat: "no-repeat",
    width: 156,
    height: 58,
    [theme.breakpoints.down("sm")]: {
      backgroundSize: "cover",
      width: 117,
      height: 44,  
    },
  },
  onMode: {
    border: "5px solid #10459a",
  },
  bold: {
    fontWeight: 600,
    [theme.breakpoints.down("sm")]: {
      fontSize: 13,
    },
  },
  modal: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 300,
    backgroundColor: theme.palette.background.paper,
    padding: 24,
  },
}));

const format = (seconds) => {
  if (isNaN(seconds)) {
    return `00:00`;
  }
  const date = new Date(seconds * 1000);
  const hh = date.getUTCHours();
  const mm = date.getUTCMinutes();
  const ss = date.getUTCSeconds().toString().padStart(2, "0");
  if (hh) {
    return `${hh}:${mm.toString().padStart(2, "0")}:${ss}`;
  }
  return `${mm}:${ss}`;
};

let count = 0;

let hideControllerDelay = -1;
const BreastVideo = ({ onViChange }) => {
  const classes = useStyles();
  const history = useHistory();
  const [state, setState] = useState({
    playing: true, // 재생
    muted: false, // 음소거
    volume: 0.5, // 음량
    playbackRate: 1.0, // 재생 속도
    played: 0,
    seeking: false,
    nCount: 0,
    start: true,
  });
  const [controlsVisible, setControlsVisible] = useState(false);
  useEffect(() =>
  {
    const intervalId = setInterval(() => {
      if(hideControllerDelay > 0)
      {
        hideControllerDelay -= 100;

        if(hideControllerDelay <= 0)
        {
          controlsRef.current.style.visibility = "hidden";
          setControlsVisible(false);
        }
      }
    }, 100);

    return () => {
      clearInterval(intervalId);
    }
  }, []);
  const [modalOpen, setModalOpen] = useState(false);  
  const reduxState = store.getState();
  const breastRe = reduxState?.breastRe?.breastData || {};
  // const menopause = breastRe.menopause == 3 || (breastRe.menopause == 2 && breastRe.age >= 50) || (!breastRe.menopause && breastRe.age >= 50) ? true : false;
  const screeningsDataCur = breastRe.age >= 70 ? screeningsData[3] : screeningsData[2];
  const [now] = useState(screeningsDataCur.scenario);
  const [bookmarks, setBookmarks] = useState([]);
  const playerRef = useRef(null);
  const playerContainerRef = useRef(null);
  const canvasRef = useRef(null);
  const controlsRef = useRef(null);
  const {
    playing,
    muted,
    volume,
    playbackRate,
    played,
    seeking,
    nCount,
  } = state;
  const handlePause = () => {
    controlsRef.current.style.visibility = "visible";
    setControlsVisible(true);
    hideControllerDelay = 3000;
    setState({ ...state, playing: !state.playing });
  };
  const handleMuted = () => {
    setState({
      ...state,
      muted: !state.muted,
      volume: state.muted ? 0.5 : 0,
    });
  };
  const handleRewind = () => {
    playerRef.current.seekTo(playerRef.current.getCurrentTime() - 10);
  };
  const handleFastForward = () => {
    playerRef.current.seekTo(playerRef.current.getCurrentTime() + 10);
  };
  const handleVolumeChange = (e, newValue) => {
    setState({
      ...state,
      volume: parseFloat(newValue / 100),
      muted: newValue === 0 ? true : false,
    });
  };
  const handleVolumeSeekDown = (e, newValue) => {
    setState({
      ...state,
      volume: parseFloat(newValue / 100),
      muted: newValue === 0 ? true : false,
    });
  };
  const handlePlaybackRateChange = (rate) => {
    setState({
      ...state,
      playbackRate: rate,
    });
  };
  const handleToggleFullScreen = (e) => {
    e.stopPropagation();
    screenfull.toggle(playerContainerRef.current);
  };
  const handleProgress = (changeState) => {
    if (count > 3) {
      controlsRef.current.style.visibility = "hidden";
      setControlsVisible(false);
      count = 0;
    }
    if (controlsRef.current.style.visibility === "visible") {
      count += 1;
    }

    hideControllerDelay = 3000;

    if (!seeking) {
      setState({
        ...state,
        ...changeState,
      });
    }
  };

  const handleSeekChange = (e, newValue) => {
    setState({ ...state, played: parseFloat(newValue / 100) });
  };

  const handleSeekMouseDown = (e) => {
    setState({ ...state, seeking: true });
  };

  const handleSeekMouseUp = (e, newValue) => {
    setState({ ...state, seeking: false });
    playerRef.current.seekTo(newValue / 100, "fraction");
  };

  const addBookmark = () => {
    const canvas = canvasRef.current;
    canvas.width = 160;
    canvas.height = 90;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(
      playerRef.current.getInternalPlayer(),
      0,
      0,
      canvas.width,
      canvas.height
    );
    const dataUri = canvas.toDataURL();
    canvas.width = 0;
    canvas.height = 0;
    const bookmarksCopy = [...bookmarks];
    bookmarksCopy.push({
      time: playerRef.current.getCurrentTime(),
      display: format(playerRef.current.getCurrentTime()),
      image: dataUri,
    });
    setBookmarks(bookmarksCopy);
  };
  const handleMouseMove = () => {
    // if (nCount + 1 === now.length) {
    //   return false;
    // }
    // if (state.played === 1) {
    //   return false;
    // }
    controlsRef.current.style.visibility = "visible";
    setControlsVisible(true);
    count = 0;
  };
  const handleMouseOut = () => {
    controlsRef.current.style.visibility = "hidden";
    setControlsVisible(false);
    count = 0;
  };
  const handleMovieChange = () => {
    if (state.nCount + 1 < now.length) {
      setState({ ...state, nCount: state.nCount + 1 });
    }
  };
  const handleMovieTrackDown = () => {
    if (state.nCount >= 1) {
      setState({ ...state, nCount: state.nCount - 1 });
    }
  };
  const handleStop = (e) => {
    e.stopPropagation();
    handlePause();
  };
  const handleTrackGo = (index) => {
    // if (now.length === index + 1) {
    //   if (
    //     playerContainerRef.current.clientWidth !== 958 &&
    //     playerContainerRef.current.clientHeight !== 539
    //   ) {
    //     screenfull.toggle(playerContainerRef.current);
    //   }
    // }
    setState({ ...state, nCount: index });
  };
  const handleTrackGoE = (e, index) => {
    e.stopPropagation();
    // if (!state.start) {
    //   alert("재생이후 이용가능합니다.");
    //   return false;
    // }
    if (now.length - 1 <= index) {
      // alert("마지막 페이지입니다.");
      onViChange(1);
      return false;
    }
    // if (now.length === index + 1) {
    //   if (
    //     playerContainerRef.current.clientWidth !== 958 &&
    //     playerContainerRef.current.clientHeight !== 539
    //   ) {
    //     screenfull.toggle(playerContainerRef.current);
    //   }
    // }
    handleTrackGo(index + 1);
  };
  const handleTrackPrevE = (e, index) => {
    e.stopPropagation();
    // if (!state.start) {
    //   alert("재생이후 이용가능합니다.");
    //   return false;
    // }
    if (now.length - 1 < 0) {
      // alert("마지막 페이지입니다.");
      onViChange(0);
      return false;
    }
    // if (now.length === index + 1) {
    //   if (
    //     playerContainerRef.current.clientWidth !== 958 &&
    //     playerContainerRef.current.clientHeight !== 539
    //   ) {
    //     screenfull.toggle(playerContainerRef.current);
    //   }
    // }
    handleTrackGo(index - 1);
  };
  const handleHome = (e) => {
    e.stopPropagation();
    history.push("/");
  };
  const currentTime = playerRef.current
    ? playerRef.current.getCurrentTime()
    : "00:00";
  const duration = playerRef.current
    ? playerRef.current.getDuration()
    : "00:00";
  const elapsedTime = format(currentTime);
  const totalDuration = format(duration);
  const handlePlay = () => {
    setState({
      ...state,
      start: true,
      playing: true,
    });
  };
  useEffect(() => {
    if (state.played === 1) {
      if (state.nCount + 1 >= now.length) {
      } else {
        handleTrackGo(state.nCount + 1);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.played]);
  return (
    <>
      <Grid
        container
        justify="center"
        alignItems="flex-start"
        className={classes.main}
      >
        <Grid
          container
          justify="center"
          // alignItems="center"
          direction="column"
          className={classes.leftRoot}
        >
          {screeningsDataCur.scenario.map((data, index) => {
            if (index !== 0 && index !== 5) {
              return (
                <Grid
                  container
                  justify="center"
                  alignItems="center"
                  className={clsx(
                    classes.leftButton,
                    state.nCount === index ? classes.onMode : null
                  )}
                  key={index}
                  onClick={(e) => handleTrackGoE(e, index - 1)}
                >
                  <Typography variant="body1" style={{ color: "#10459a" }}>
                    <span className={classes.bold}>{data.title}</span>
                  </Typography>
                </Grid>
              );
            }
          })}
        </Grid>
        <Grid
          className={classes.rightRoot}
          container
          direction="column"
          justify="center"
          alignItems="center"
        >
          <Grid container className={classes.titleLine}>
            <Typography variant="h2" align="center" className={classes.titleText}>
              유방암 조기 검진 받는 것이 좋을까요?
            </Typography>
          </Grid>
          {/* <Grid container className={classes.titleLine}>
            {screeningsDataCur.scenario.map((data, index) => {
              if (index !== 0 && index !== 5) {
                return (
                  <Grid
                    container
                    justify="center"
                    alignItems="center"
                    className={clsx(
                      classes.topButton,
                      state.nCount === index ? classes.onMode : null
                    )}
                    key={index}
                    onClick={(e) => handleTrackGoE(e, index - 1)}
                  >
                    <Typography variant="h5" style={{ color: "#10459a" }}>
                      <span className={classes.bold}>{data.title}</span>
                    </Typography>
                  </Grid>
                );
              }
            })}
          </Grid> */}
        <Grid
          className={classes.leftRootMd}
          style={{ flex: 1, alignSelf: 'stretch', flexDirection: 'row', justifyContent: 'space-between'} }
        >
          {screeningsDataCur.scenario.map((data, index) => {
            if (index !== 0 && index !== 5) {
              return (
                <Grid
                  container
                  justify="center"
                  alignItems="center"
                  className={clsx(
                    classes.leftButton,
                    state.nCount === index ? classes.onMode : null
                  )}
                  key={index}
                  onClick={(e) => handleTrackGoE(e, index - 1)}
                >
                  <Typography variant="body1" style={{ color: "#10459a" }}>
                    <span className={classes.bold}>{data.title}</span>
                  </Typography>
                </Grid>
              );
            }
          })}
        </Grid>          
          <Grid>
            <Grid
              container
              justify="center"
              alignItems="center"
              className={classes.root}
            >
              {!state.start && (
                <Grid
                  container
                  justify="center"
                  alignItems="center"
                  className={classes.playerMain}
                >
                  <IconButton
                    color="primary"
                    aria-label="add an alarm"
                    onClick={handlePlay}
                  >
                    <PlayArrowIcon style={{ fontSize: 120 }} />
                  </IconButton>
                </Grid>
              )}
              <div
                ref={playerContainerRef}
                className={classes.playerWrapper}
                onMouseMove={handleMouseMove}
                onMouseOut={handleMouseOut}
                onClick={handleStop}
              >
                {/* <Grid
                  container
                  className={classes.titleMain}
                  style={{ position: "absolute" }}
                >
                  <div>{now[nCount].title}</div>
                </Grid> */}
                {/* {state.played === 1 && nCount + 1 !== now.length && (
                  <Grid
                    container
                    alignItems="flex-end"
                    justify="flex-end"
                    className={classes.next}
                    style={{ position: "absolute" }}
                  >
                    <div onClick={(e) => handleTrackGoE(e, nCount)}>
                      다음
                      <ArrowForwardIcon />
                    </div>
                  </Grid>
                )} */}
                <ReactPlayer
                  url={now[nCount].url}
                  muted={muted}
                  width={"100%"}
                  height={"100%"}
                  playing={playing}
                  ref={playerRef}
                  volume={volume}
                  playbackRate={playbackRate}
                  onProgress={handleProgress}
                  onEnded={() => { if(state.nCount == now.length - 1) setModalOpen(true); }}
                  allow="autoplay"
                  style={{
                    // display: nCount === now.length && "none",
                    marginBottom: -5,
                  }}
                  config={{
                    file: {
                      attributes: {
                        // "Access-Control-Allow-Origin": "dd",
                        // crossOrigin: nCount % 2 === 0 ? "anonymous" : "anonymous",
                        // autoPlay: true,
                      },
                    },
                  }}
                />
                {/* {nCount + 1 === now.length && (
                  <Form name={screeningsDataCur.name} />
                )} */}
                <PlayerControls
                  ref={controlsRef}
                  onPlayPause={handlePause}
                  playing={playing}
                  muted={muted}
                  volume={volume}
                  onRewind={handleRewind}
                  onFastForward={handleFastForward}
                  onVolumeSeekDown={handleVolumeSeekDown}
                  onVolumeChange={handleVolumeChange}
                  onMuted={handleMuted}
                  playbackRate={playbackRate}
                  onPlaybackRateChange={handlePlaybackRateChange}
                  onToggleFullScreen={handleToggleFullScreen}
                  played={played}
                  onSeek={handleSeekChange}
                  onSeekMouseDown={handleSeekMouseDown}
                  onSeekMouseUp={handleSeekMouseUp}
                  elapsedTime={elapsedTime}
                  totalDuration={totalDuration}
                  onBookmark={addBookmark}
                  onMoviePlus={handleMovieChange}
                  onMovieTrackDown={handleMovieTrackDown}
                  nCount={nCount}
                  leng={now.length}
                  title={now[nCount].title}
                  cancerData={screeningsDataCur}
                  onTrackGo={handleTrackGo}
                  onGoHome={handleHome}
                  visible={controlsVisible}
                  // style={{
                  //   display:
                  //     (nCount + 1 === now.length || state.played === 1) &&
                  //     "none",
                  // }}
                />
              </div>
            </Grid>
          </Grid>
          <Grid
            container
            justify="flex-end"
            alignItems="center"
            className={classes.footer}
          >
            {
              nCount > 0 ? (
                <>
                <Grid
                  container
                  justify="center"
                  alignItems="center"
                  className={classes.prevButton}
                  onClick={(e) => handleTrackPrevE(e, nCount)}
                >
                  <ArrowBackIcon style={{ fontSize: 16 }} />
                  &nbsp;이전
                </Grid>
                <Grid
                  container
                  justify="center"
                  alignItems="center"
                  className={classes.prevButtonSmall}
                  onClick={(e) => handleTrackPrevE(e, nCount)}
                >
                  <ArrowBackIcon style={{ fontSize: 16 }} />
                  &nbsp;이전
                </Grid>
                </>  
              ) : null
            }
            <Grid
              container
              justify="center"
              alignItems="center"
              className={classes.nextButton}
              onClick={(e) => handleTrackGoE(e, nCount)}
            >
              다음&nbsp;
              <ArrowForwardIcon style={{ fontSize: 16 }} />
            </Grid>
            <Grid
              container
              justify="center"
              alignItems="center"
              className={classes.nextButtonSmall}
              onClick={(e) => handleTrackGoE(e, nCount)}
            >
              다음&nbsp;
              <ArrowForwardIcon style={{ fontSize: 16 }} />
            </Grid>
            <Grid className={classes.logo}></Grid>
          </Grid>
        </Grid>
      </Grid>
      <Modal
        open={modalOpen}
        onClose={() => { setModalOpen(false); }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className={classes.modal}>
          <Typography id="modal-modal-title" variant="h4" style={{ textAlign: 'center' }}>
            시청을 마치셨습니다.
            <br />
            <br />
            '다음' 버튼을 눌러 진행해주세요.
          </Typography>
          <Grid
            container
            justify="center"
            alignItems="center"
            style={{ marginTop: 24 }}
          >
            <Button
              color="primary"
              variant="contained"
              fullWidth
              onClick={() => { onViChange(1); }}
            >
              다음
            </Button>
          </Grid>
        </Box>
      </Modal>
    </>
  );
};

export default BreastVideo;
